import { render, staticRenderFns } from "./StallInfo.vue?vue&type=template&id=0c2a3c8a&scoped=true&"
import script from "./StallInfo.vue?vue&type=script&lang=js&"
export * from "./StallInfo.vue?vue&type=script&lang=js&"
import style0 from "../../less/store.less?vue&type=style&index=0&id=0c2a3c8a&lang=less&scoped=true&"
import style1 from "./StallInfo.vue?vue&type=style&index=1&id=0c2a3c8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2a3c8a",
  null
  
)

export default component.exports